"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeparturePickerValue = void 0;
var _react = _interopRequireDefault(require("react"));
var _localization = require("@lt/localization");
var DeparturePickerValue = exports.DeparturePickerValue = function DeparturePickerValue(props) {
  var isDisabled = props.isDisabled,
    currentValue = props.currentValue,
    children = props.children;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return isDisabled && currentValue ? /*#__PURE__*/_react["default"].createElement("span", null, t('hotel.cigarette.mobile.from'), currentValue.selectedLabel) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};